import {
  Flex,
  Box,
  IconButton,
  Image,
  useColorMode,
  Spacer,
  Switch,
  Text,
} from "@chakra-ui/react";
import { updatedoctoravailability } from "../../middleware/services/home";
import React, { useEffect, useState, useRef } from "react";
import { getProfileforhome } from "../../middleware/services/profile";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import GPUGenericChatbot from "../generic-chatbot/gpuIndex";
import GenericChatbot from "../generic-chatbot";
import { getIsDoctor, getLoginID, IsDoctorAvailable } from "../../auth";
import CPUTranscribeNotes from "../patient-health/doctor-notes/notes-transcription/CPU-transcription";
import GPUChunksTranscribeNotes from "../patient-health/doctor-notes/notes-transcription/GPU-chunks-notes-transcription";
import Toaster from "../toaster";
import DynamicModal from "../dynamic-modal";
import AudioCompatibilityCheck from "../patient-health/doctor-notes/notes-transcription/compatibility-check";


function SecondaryNav({
  defaultNavBody,
  withBack,
  withBackBody,
  onBack,
  showBack = false,
  goBack,
  isAvailable = true,
  isSwitchChecked = false,
  onSwitchChange,
  isDark = false,
  customHeader,
  nextConsult = true,
  // hospitalLogoUrl, 
  // hospitalName = "City Care Hospital and Research Center", 
}) {
  const [shouldCloseSocket, setShouldCloseSocket] = useState(false);

  const { showSuccessToast, showErrorToast } = Toaster();

  const closeChatBotOnEndVisit = () => {
    setShouldCloseSocket(true);
  };

  const resetCloseSocketCommand = () => {
    setShouldCloseSocket(false);
  };

  const useGPUChatbot = !!navigator.gpu;
  // const useGPUChatbot = false;

  const [DoctorAvailability, setDoctorAvailability] = useState("");
  const [doctorId, setDoctorId] = useState(getLoginID());
  const [isDoctor, setIsDoctor] = useState(1);
  const { isLoading, showLoader, dismissLoader } = useLoader();

  //-------------------------AIRA Notes Transcription
  const airaTranscribeNotes = useRef(null);

  const audioCompatibilityDemo = useRef(null);

  const handleAIRANotesClick = () => {
    if (!useGPUChatbot) {
      // Case 1: If useGPUChatbot is false
      airaTranscribeNotes.current.openModal();
    } else {
      // Case 2: If useGPUChatbot is true
      const capableGPU = localStorage.getItem("capableGPU");
      console.log("capableGPU is set to", capableGPU);

      // newly added block
      if (capableGPU === null || capableGPU === "false") {
      // Do NOT trigger audioCompatibilityDemo if "false"
      airaTranscribeNotes.current.openModal();
      } else {
        airaTranscribeNotes.current.openModal();
      }

      // existing block of code
      // if (capableGPU === null) {
      //   // If capableGPU does not exist
      //   audioCompatibilityDemo.current.openModal();
      // } else {
      //   // If capableGPU exists (either "true" or "false")
      //   airaTranscribeNotes.current.openModal();
      // }
    }
  };

  const [logoUrl, setLogoUrl] = useState("/assets/imgs/no-image.png");
const [hospitalName, setHospitalName] = useState("");

useEffect(() => {
  // Get values from localStorage
  const storedLogo = localStorage.getItem("hosplogo");
  const storedHospitalName = localStorage.getItem("hospname"); // Note: corrected key name
  
  // Update state with stored values or defaults
  if (storedLogo) {
    setLogoUrl(storedLogo);
  }
  
  if (storedHospitalName) {
    setHospitalName(storedHospitalName);
  }
}, []);
  // useEffect(() => {
  //   getDoctorProfile();
  // }, []);
  const isavailable = IsDoctorAvailable();
  const currentdoctor = getIsDoctor();

  const switchclicked = async (e) => {
    const isChecked = e.target.checked;
    let input = { doctorid: "", isavailable: "" };
    // Do something based on the checked status
    if (isChecked) {
      // Switch is checked
      input.isavailable = "1";
    } else {
      // Switch is not checked
      input.isavailable = "0";
    }
    const result = await updatedoctoravailability(input);
    if (result.output.success === 1) {
      getDoctorProfile();
      var doctorDetails = localStorage.getItem("LoginInfo");
      if (doctorDetails) {
        var formateddata = JSON.parse(doctorDetails);
        const isavail = parseInt(input.isavailable);
        const updatedDoctorDetails = { ...formateddata, isavailable: isavail };
        localStorage.setItem("LoginInfo", JSON.stringify(updatedDoctorDetails));
      }
    }
  };
  var inputForGet = {};
  const getDoctorProfile = async () => {
    //showLoader();
    try {
      var result = await getProfileforhome(inputForGet);
      if (result && result.ProfileOutput) {
        setDoctorAvailability(result.ProfileOutput);
        setIsDoctor(result.ProfileOutput.isdoctor);
      }
      //dismissLoader();
    } catch (error) {
      console.log(error, "Something went wrong in doctor profile");
    }
  };

  const isChatbotAllowed = () => {
  const subscriptionName = localStorage.getItem("subscriptionName");
  const subscriptionEndDate = localStorage.getItem("subscriptionEndDate");
  
  // If either value is missing, assume chatbot is allowed (or you can handle differently)
  if (!subscriptionName || !subscriptionEndDate) return true;
  
  // Check if subscription is Basic and end date has passed
  const currentDate = new Date();
  const endDate = new Date(subscriptionEndDate);
  
  // return !(subscriptionName === "Basic");
  return !(subscriptionName === "Basic" && currentDate > endDate);
};

  return (
    <Flex
      as="nav"
      align="center"
      alignItems="center"
      justify="space-between"
      wrap="wrap"
      bg="#FFFFFF"
      color="white"
      h="5rem"
      pl='1.5rem'
      pr='0.5rem'
      // p="1rem 1.5rem"
      borderBottom="1px solid #E6E7E9"
    >
      {isLoading && <Loader />}
      {/* Back button handling */}
      {showBack && onBack && (
        <Image
          mr="4px"
          src="/assets/svgs/left-tab-icon.svg"
          onClick={onBack}
          cursor="pointer"
        />
      )}
      {customHeader && (
        <Box>
          <Text fontSize="1.25rem" fontWeight="600" color="black">
            {customHeader}
          </Text>
        </Box>
      )}
      {withBack && (
        <Box
          as="button"
          display="flex"
          flexDirection="row"
          alignItems="center"
          gap="10px"
          sx={{ bg: "none", _hover: { bg: "none" } }}
          onClick={goBack}
        >
          {/* <Box> */}
          <Image w="15px" mr="5px" src="/assets/imgs/arrow_back.png" />
          <Box as="h1" color="black" fontSize="20px">
            {withBack}
          </Box>
          {/* </Box> */}
        </Box>
      )}
      <Spacer />
      {defaultNavBody}
      {withBackBody}
      {DoctorAvailability && DoctorAvailability.nextconsultationin && (
        <Box>
          <Box
            as="button"
            display="flex"
            alignItems="center"
            bg="transparent"
            p="0.5rem 0.75rem"
            h="2.5rem"
            gap="0.625rem"
            border="1px solid #E6E7E9"
            borderRadius=".625rem"
          >
            <Image src="/assets/svgs/home-calendar.svg" />
            <Text fontSize="0.87rem" fontWeight="500" color="#384052">
              Next consultation in {DoctorAvailability.nextconsultationin}
            </Text>
            <Image src="/assets/imgs/right-icon.png" />
          </Box>
        </Box>
      )}
      <Box display="flex" alignItems="center" flexWrap="nowrap">
        {useGPUChatbot ? (
          <GPUGenericChatbot
            closeSocketCommand={shouldCloseSocket}
            resetCloseSocketCommand={resetCloseSocketCommand}
            doctorId={doctorId}
            height="100%"
          />
        ) : (
          <GenericChatbot
            closeSocketCommand={shouldCloseSocket}
            resetCloseSocketCommand={resetCloseSocketCommand}
            doctorId={doctorId}
            height="100%"
          />
        )}

        <div>
          <Box
            as="button"
            borderRadius="md"
            // onClick={handleAIRANotesClick}
            onClick={isChatbotAllowed() ? handleAIRANotesClick : null}
            zIndex="5"
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="5px"
            w="100px"
            h="2.2rem"
            // mr={"4px"}
            ml="0.75rem"
            left={{ lg: "80%", xl: "80%" }}
            // backgroundImage="linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)"
            backgroundImage={isChatbotAllowed() ? 
      "linear-gradient(to right top, #0d7e54, #007774, #006d94, #005ea7, #1146a0)" : 
      "linear-gradient(to right top, #6b6b6b, #5f5f5f, #545454, #484848, #3d3d3d)"}
    opacity={isChatbotAllowed() ? 1 : 0.7}
    cursor={isChatbotAllowed() ? "pointer" : "not-allowed"}
    _hover={isChatbotAllowed() ? { 
      backgroundImage: "linear-gradient(to right top, #0a6a46, #00646b, #005b83, #004d95, #0d3a85)"
    } : {}}
    title={!isChatbotAllowed() ? "Please upgrade your subscription to use this feature" : ""}
          >
            <Image w="16px" src="/assets/imgs/white-spark.png" opacity={isChatbotAllowed() ? 1 : 0.5}  />
            <Box display="flex" flexDir="column">
              <Text
                textAlign="left"
                fontSize="10px"
                fontWeight="700"
                color="white"
              >
                Record
              </Text>
            </Box>
          </Box>
        </div>

        {/* Hospital Logo and Name */}
        <Box ml="0.75rem">
          <Box
            display="flex"
            alignItems="center"
            bg="transparent"
            // p="0.1rem 0.75rem"
            pl='0.5rem'
            // h="2.5rem"
            h="4.5rem"
            gap="0.75rem"
            border="1px solid #E6E7E9"
            // borderRadius=".625rem"
            borderTopLeftRadius=".625rem"
            borderBottomLeftRadius=".625rem"
            minWidth="200px"
            maxWidth="240px"
            // minWidth="180px"
            // maxWidth="220px"
            cursor="pointer"
            title={hospitalName}
            // title={"City Care Hospital and Research Center"}
            _hover={{
              bg: "#f8f9fa",
              borderColor: "#d1d5db",
            }}
          >

            {/* Hospital Name */}
            <Box 
              display="flex" 
              flexDirection="column" 
              alignItems="flex-start"
              justifyContent="center"
              minWidth="0"
              flex="1" 
            >
              {/* <Text
                fontSize="0.75rem"
                fontWeight="600"
                color="#384052"
                lineHeight="1.1"
                noOfLines={2}
                textAlign="left"
                wordBreak="break-word"
                whiteSpace="nowrap"  // Prevent wrapping at 100-110% zoom
                overflow="hidden"
                textOverflow="ellipsis"
                width="100%"
              > */}
                <Text
                fontSize="1rem"  // Smaller font for two-line display
                fontWeight="700"
                color="#384052"
                lineHeight="1.1"
                noOfLines={2}  // Chakra UI prop to limit to 2 lines
                textAlign="left"
                wordBreak="break-word"
              >
                {hospitalName}
                {/* City Care Hospital and Research Center */}
              </Text>
            </Box>

            {/* Hospital Logo */}
            <Image 
              // src={hospitalLogoUrl || "/assets/imgs/no-image.png"} 
              src={logoUrl} 
              alt="Hospital Logo"
              w="70px" 
              h="70px"
              // w="32px" 
              // h="32px"
              objectFit="contain"
              flexShrink={0}
              onError={(e) => {
      // Fallback if image fails to load
      e.target.src = "/assets/imgs/no-image.png";
    }}
            />
          </Box>
        </Box>

        {/* existing code for Available & Unavailable */}
        {/* {currentdoctor && (
          <Box ml="0.75rem">
            <Box
              as="button"
              display="flex"
              alignItems="center"
              bg="transparent"
              p="0.5rem 0.75rem"
              h="2.5rem"
              gap="0.625rem"
              border="1px solid #E6E7E9"
              borderRadius=".625rem"
            >
              {isavailable === 1 ? (
                <>
                  <Image src="/assets/svgs/online-circle.svg" />
                  <Text fontSize="0.87rem" fontWeight="500" color="#384052">
                    Available
                  </Text>
                  <Switch
                    colorScheme="green"
                    onChange={(e) => switchclicked(e)}
                    defaultChecked
                  />
                </>
              ) : (
                <>
                  <Text fontSize="0.87rem" fontWeight="500" color="#384052">
                    Unavailable
                  </Text>
                  <Switch
                    colorScheme="green"
                    onChange={(e) => switchclicked(e)}
                  />
                </>
              )}
            </Box>
          </Box>
        )} */}
      </Box>
      <DynamicModal
        ref={airaTranscribeNotes}
        modalHeader="Aira: Notes"
        hasHeader={false}
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <TranscribeNotes /> */}
            {useGPUChatbot && localStorage.getItem("capableGPU") === "true" ? (
              (() => {
              return (
              <GPUChunksTranscribeNotes
                patientId={null}
                doctorId={null}
                appointmentId={null}
                showSuccessToast={showSuccessToast}
                showErrorToast={showErrorToast}
                closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                fetchPatientHealthData={() => {}}
                fromStartVisit={false}
                isDischargeSummary={false}
              />
               );
                })()
            ) : (
               (() => {
          return (
              <CPUTranscribeNotes
                patientId={null}
                doctorId={null}
                appointmentId={null}
                showSuccessToast={showSuccessToast}
                showErrorToast={showErrorToast}
                closeNotesModal={() => airaTranscribeNotes.current.closeModal()}
                fetchPatientHealthData={() => {}}
                fromStartVisit={false}
                isDischargeSummary={false}
              />
               );
        })()
            )}
          </>
        }
        // modalFooterBtn={
        //   <>
        //     <PrimaryButton
        //       variant="deleteBtn"
        //       buttonText="Close"
        //       w="200px"
        //       mx="auto"
        //       onClick={() => airaTranscribeNotes.current.closeModal()}
        //     />
        //   </>
        // }
      />
      <DynamicModal
        ref={audioCompatibilityDemo}
        modalHeader="Aira: Config"
        modalWidth={"100vw"}
        modalHeight={"100vh"}
        hasFooter={false}
        modalBody={
          <>
            {/* <AIRA CHAT NOTES /> */}
            <AudioCompatibilityCheck modalRef={audioCompatibilityDemo} openRecordFunction={handleAIRANotesClick}/>
          </>
        }
      />
      ;
    </Flex>
  );
}

SecondaryNav.defaultProps = {
  defaultHeader: null,
  defaultSecondayHeader: null,
  defaultNavBody: null,
  withBackBody: null,
  withBack: null,
  onBack: null,
  // hospitalLogoUrl: null,
  // hospitalName: "City Care Hospital and Research Center",
};

export default SecondaryNav;
